module.exports = __webpack_public_path__ + "media/images/media-elements/expand-8a11cf4d52923f204bd2eceb950933ed.svg";